module.exports = __webpack_public_path__ + "static/media/TextShort.15af598a.svg";